import React from "react";
import fourDotLoader from "assets/icons/FourDotLoader.gif";
import "./RealesyAnimatedLoaders.css";

const BRAND_MARK = (
  <svg className="realesy-ring-logo" viewBox="0 0 64 64" aria-hidden="true">
    <path d="M7 31 27 13Q34 7 41 13L57 25 47 34 34 24 13 42Q5 45 4 38Z" fill="#ff9200" />
    <path
      d="M18 39 34 27 49 38Q53 41 53 46V54Q53 58 49 58H39V48Q39 44 35 44T31 48V58H17Q12 58 12 53V46Q12 42 18 39Z"
      fill="#2864e8"
    />
  </svg>
);

export type RealesyLoaderVariant = "wave" | "cube" | "ring" | "dots";

export function BounceDotsLoader() {
  return (
    <img
      className="realesy-four-dots"
      src={fourDotLoader}
      alt=""
      width={104}
      height={101}
    />
  );
}

export function BrandRingLoader() {
  return (
    <div className="realesy-ring" role="status" aria-label="Loading">
      {BRAND_MARK}
    </div>
  );
}

export function WaveLoader() {
  return (
    <div className="realesy-wave" role="status" aria-label="Loading">
      <i />
      <i />
      <i />
      <i />
      <i />
      <i />
      <i />
      <i />
      <i />
    </div>
  );
}

export function CubeLoader() {
  return (
    <div className="realesy-cube" role="status" aria-label="Loading">
      <i />
      <i />
      <i />
    </div>
  );
}

export function RealesyAnimatedLoader({ variant }: { variant: RealesyLoaderVariant }) {
  if (variant === "wave") return <WaveLoader />;
  if (variant === "cube") return <CubeLoader />;
  if (variant === "dots") return <BounceDotsLoader />;
  return <BrandRingLoader />;
}
